import React from "react";
import PayRollTable from "../../../../components/Tables/PayRollTable";
import { useSelector } from "react-redux";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export default function Salary({ employeeName }) {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { EmployeeSalarydata } = useSelector((state) => state.PayRollSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  // ✅ SAFE ROWS (Dtl)
  const getRows =
    EmployeeSalarydata?.Dtl?.map((label, index) => ({
      id: index + 1,
      DeptName: label?.DeptName || "-",
      Designation: label?.Designation || "-",
      MonthName: label?.MonthName || "-",
      PDays: label?.PDays || 0,
      Rate: label?.Rate || 0,
      Salary: label?.Salary || 0,
      TotalSalary: label?.TotalSalary || 0,
      SalType: label?.SalType || "-",
    })) || [];

  const getColumns = [
    {
      key: "id",
      label: "ID",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "DeptName",
      label: "Department",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "Designation",
      label: "Designation",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "MonthName",
      label: "Month",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "SalType",
      label: "SalType",
      aligm: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "PDays", label: "Present Days", align: "right" },
    { key: "Rate", label: "Rate", align: "right", format: "true" },
    { key: "Salary", label: "Salary", align: "right", format: "true" },
    {
      key: "TotalSalary",
      label: "Total Salary",
      align: "right",
      format: "true",
    },
  ];

  // ✅ SAFE ROWS (Summ)
  const getRows1 =
    EmployeeSalarydata?.Summ?.map((label, index) => {
      console.log("Row Data =>", label);

      return {
        id: index + 1,
        DeptName: label?.Deptname || "-",
        Designation: label?.Designation || "-",
        NoOfDay: label?.NoOfDay || 0,
        AvgRate: label?.AvgRate || 0,
      };
    }) || [];

  const getColumns1 = [
    {
      key: "id",
      label: "ID",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "DeptName",
      label: "Department",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "Designation",
      label: "Designation",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "NoOfDay", label: "No Of Day", align: "right" },
    { key: "AvgRate", label: "Avg Rate", align: "right" },
  ];

  // ✅ Employee select check
  if (!employeeName || employeeName.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
          fontSize: "18px",
          color:
            isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour10,
        }}
      >
        Please Select Employee Name
      </div>
    );
  }

  // ✅ Loader check
  if (EmployeeSalarydata === "no" || EmployeeSalarydata === null) {
    return (
      <div
        style={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div>
      {/* SUMMARY TABLE */}
      <div
        style={{
          marginTop: "25px",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          DEPARTMENTWISE SALARY SUMMARY
        </div>

        <PayRollTable columns={getColumns1} data={getRows1} />
      </div>

      {/* DETAIL TABLE */}
      <div
        style={{
          marginTop: "25px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          EMPLOYEE SALRY DETAILS
        </div>

        <PayRollTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
